<a
  href="https://t.me/IRani_Expert"
  target="_blank"
  rel="nofollow noopener noreferrer"
  aria-label="کانال تلگرام IRani Expert"
  class="block w-full"
>
  <i class="banner-header-gif relative z-50 h-9 lg:h-14 w-full object-cover"></i>
</a>

<scroll-to-top />

<main class="m-0 p-0 gap-0 flex flex-col min-h-screen overflow-hidden lg:overflow-y-hidden overflow-x-hidden bg-white">

  <app-header-layout></app-header-layout>
  <div class="hidden lg:block my-4 mr-4">
    <app-bread-crumb></app-bread-crumb>
  </div>
  <span class="hidden lg:block circle-on-top"></span>
  <div class="self-auto padding-all transition-custom lg:self-center max-w-screen-2xl flex-grow w-full relative rounded-b-[2rem] z-0">
    <router-outlet></router-outlet>
  </div>
  <div class="footer-seprator"></div>
  <app-footer></app-footer>

</main>

<ng-container *ngIf="_platformValue">
  <app-loader class="block" [ngClass]="httpLoader ? '' : 'hidden'">
    <i class="loader-gif w-96"></i>
  </app-loader>
</ng-container>
